export enum BookingStatusEnum {
  VALIDATED = 'VALIDATED',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING',
  FAILURE = 'FAILURE',
  DRAFT = 'DRAFT',
  NC = 'NC',
}
